import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@mui/material/Typography';
import get from 'lodash/get';

import Moment from 'moment';

import { useRecordContext } from 'react-admin';

const ExpirationDateField = ({ record: recordProp, source, value }) => {
    const contextRecord = useRecordContext();
    const record = recordProp || contextRecord;
    const expiredAt = value ? value : get(record, source);

    if (!expiredAt) return null;

    const expiredAtDate = new Date(expiredAt);
    const color = expiredAtDate < new Date() ? 'error' : 'textPrimary';

    return (
        <Typography component="span" variant="body2" color={color}>
            { Moment(expiredAt).format('MM/DD/YYYY') }
        </Typography>
    );
};

ExpirationDateField.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string,
    value: PropTypes.string,
};

export default ExpirationDateField;
